setTimeout(function() {
  const scrollToElement = (element, offset) => {
    window.scrollTo({
      top: element + offset,
      behavior: 'smooth'
    });
  };
  if (document.body.classList.contains('geisha-new')){
    // Attach click event listener to the button
    document.getElementById('scrolltoProOne').addEventListener('click', () => {
      const targetElement = document.querySelector('#shopify-section-template--17970984059146__6829c3fc-ff4c-4493-8b65-10417809d133');
      const targetOffset = targetElement.getBoundingClientRect().top + window.pageYOffset;
      const offsetAdjustment = 90;
      scrollToElement(targetOffset, -offsetAdjustment);
    });
    document.getElementById('scrolltoProTwo').addEventListener('click', () => {
      const targetElement = document.querySelector('#shopify-section-template--17970984059146__6829c3fc-ff4c-4493-8b65-10417809d133');
      const targetOffset = targetElement.getBoundingClientRect().top + window.pageYOffset;
      const offsetAdjustment = 120;
      scrollToElement(targetOffset, -offsetAdjustment);
    });
  }

  if (document.body.classList.contains('natuerliche-schoenheit')){
    document.getElementById('scrolltoProOne_schonheit').addEventListener('click', () => {
      const targetElement = document.querySelector('#shopify-section-template--17938357715210__6829c3fc-ff4c-4493-8b65-10417809d133');
      const targetOffset = targetElement.getBoundingClientRect().top + window.pageYOffset;
      const offsetAdjustment = 90;
      scrollToElement(targetOffset, -offsetAdjustment);
    });
    document.getElementById('scrolltoProTwo_schonheit').addEventListener('click', () => {
      const targetElement = document.querySelector('#shopify-section-template--17938357715210__6829c3fc-ff4c-4493-8b65-10417809d133');
      const targetOffset = targetElement.getBoundingClientRect().top + window.pageYOffset;
      const offsetAdjustment = 120;
      scrollToElement(targetOffset, -offsetAdjustment);
    });
  }
  

  
  const productSlideshowActions = document.querySelectorAll('.product-slideshow__action');
  productSlideshowActions.forEach((action) => {
    action.addEventListener('mouseover', () => {
      const parent = action.closest('.ProductMetaBoxTooltip');
      const tooltip = parent.querySelector('.product-slideshow__tooltip');
      tooltip.style.opacity = '1';
      tooltip.style.visibility = 'visible';
    });
    action.addEventListener('mouseout', () => {
      const parent = action.closest('.ProductMetaBoxTooltip');
      const tooltip = parent.querySelector('.product-slideshow__tooltip');
      tooltip.style.opacity = '0';
      tooltip.style.visibility = 'hidden';
    });
  });
}, 3000);